import React from 'react';
import {i18n} from 'react-i18n';
import AppStore from '../stores/AppStore';
import AppActions from '../actions/AppActions';
import TemplateData from '../utility/getTemplateData';
import GlobalBanner from '../common/globalBanner';
import SubHeader from '../common/subHeader';
import Amount from '../common/amount';
import CancelAndReturn from '../common/cancelAndReturn';

const STYLES = {
	donateBtn: {
		maxWidth: '360px',
		margin: '20px auto'
	},
	centralFormWrapper: {
		width: '400px',
		margin: '0 auto'
	},
	donationSeparator: {
		marginBottom: '25px'
	},
	formLabelBold: {
		fontWeight: 'bold'
	},
	formLabelLeft: {
		width: '50%',
		textAlign: 'left'
	},
	formLabelRight: {
		width: '50%',
		textAlign: 'right'
	},
	formLabelCenter: {
		width: '100%',
		marginTop: '10px',
		textAlign: 'center'
	},
	conversionBlock: {
		margin: '20px 15px 30px 15px',
		padding: '15px 0 10px 0',
		backgroundColor: '#F1F8FC',
		borderRadius: '5px'
	},
	policyMsg: {
		fontSize: '0.85em',
		textAlign: 'center',
		color: '#848B8E'
	}
};

const CrossBorder = React.createClass({
	mixins: [i18n('guest/crossBorder')],

	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	getInitialState() {
		let fundingOptions = AppStore.getFundingOptions();
		let [fundingSources] = fundingOptions.sources;
		let paymentNetwork = fundingSources.payment_card.network.toLowerCase();
		paymentNetwork = paymentNetwork.charAt(0).toUpperCase() + paymentNetwork.slice(1);
		let paymentDigits = fundingSources.payment_card.last_4;
		let exchangeRate = parseFloat(
			fundingOptions.currency_conversion.exchange_rate
		).toFixed(2);
		let fundsIn = fundingOptions.currency_conversion.funds_in;
		let fundsOut = fundingOptions.currency_conversion.funds_out;

		return {
			exchangeRate,
			subHeaderLabel: TemplateData.donationName,
			amountDecimalPoint: TemplateData.donationDecimalPoint || '.',
			paymentCard: `${paymentNetwork} x-${paymentDigits}`,
			inAmount: fundsIn.value,
			inCurrency: fundsIn.currency,
			inSymbol: fundsIn.symbol,
			outAmount: fundsOut.value,
			outCurrency: fundsOut.currency,
			outSymbol: fundsOut.symbol
		};
	},

	getLocalizedAmount(amount) {
		amount = (parseFloat(amount)).toFixed(2);
		return `${amount}`.replace(/[.|,]/i, this.state.amountDecimalPoint);
	},

	handleDonateClick() {
		$('.spinneroverlay').show();

		$.post('/donate/guest/fullfilment', {
			note: AppStore.getDonationNote(),
			fundingOptionId: AppStore.getFundingOptions().id,
			email: AppStore.getEmail(),
			billingAddress: AppStore.getBillingAddress()
		}, (result) => {
			if (result.status === 'redirect') {
				window.location.href = result.url;
			} else if (result.data && result.data.confirmationData) {
				let confirmationData = result.data.confirmationData || {};

				AppActions.updateConfirmation({confirmation: confirmationData});

				if (confirmationData.isOfacPending) {
					this.context.router.push('/donate/guest/pending');
				} else {
					this.context.router.push('/donate/guest/confirmation');
				}
			} else {
				window.location.href = '/donate/error/payment';
			}
		}).fail(() => {
			window.location.href = '/donate/error/payment';
		}).always(() => {
			$('.spinneroverlay').hide();
		});
	},

	render() {
		const inAmount = this.getLocalizedAmount(this.state.inAmount);
		const outAmount = this.getLocalizedAmount(this.state.outAmount);
		const fundsIn = `${this.state.inSymbol}${inAmount} ${this.state.inCurrency}`;
		const fundsOut = `${this.state.outSymbol}${outAmount} ${this.state.outCurrency}`;
		const exchangeRate = `${this.getLocalizedAmount('1.00')} ${this.state.inCurrency} = ${this.getLocalizedAmount(this.state.exchangeRate)} ${this.state.outCurrency}`;

		return (<div className="donate_wrapper">
			<div id="crossBorderContainer" className="container">
				<GlobalBanner logourl={this.state.logourl}/>
				<SubHeader label={this.state.subHeaderLabel}/>
				<Amount
					amount={inAmount}
					symbol={this.state.inSymbol}
					code={this.state.inCurrency}/>

				<div style={STYLES.centralFormWrapper}>
					<label style={STYLES.formLabelBold}>
						{this.i18n('label.donatingFrom')}
					</label>
					<div
						className="donate_linner_div center-block"
						style={STYLES.donationSeparator}/>

					<label style={STYLES.formLabelLeft}>
						{this.state.paymentCard}
					</label>
					<label style={STYLES.formLabelRight}>
						{fundsIn}
					</label>
				</div>

				<div style={STYLES.conversionBlock}>
					<div style={STYLES.centralFormWrapper}>
						<label style={{
							...STYLES.formLabelLeft,
							...STYLES.formLabelBold}}>
							{this.i18n('label.youDonate')}
						</label>
						<label style={{
							...STYLES.formLabelRight,
							...STYLES.formLabelBold}}>
							{fundsIn}
						</label>

						<label style={STYLES.formLabelLeft}>
							{this.i18n('label.charityGet')}
						</label>
						<label style={STYLES.formLabelRight}>
							{fundsOut}
						</label>

						<label style={STYLES.formLabelCenter}>
							{this.i18n('label.conversion')} {exchangeRate}
						</label>
					</div>
				</div>

				<div
					style={STYLES.policyMsg}
					dangerouslySetInnerHTML={{__html: this.i18n('label.policies')}}/>

				<div style={STYLES.donateBtn}>
					<button
						type="button"
						className="vx_btn vx_btn-block"
						onClick={this.handleDonateClick}>
						{this.i18n('label.donatenow')}
					</button>
				</div>
				<CancelAndReturn />
			</div>
		</div>);
	}
});

export default CrossBorder;



// WEBPACK FOOTER //
// ./guest/crossBorder.js